// ============================================================================
// Widget — Cash Collected (actual vs target, time series)
// ============================================================================
import React from 'react';
import ReactECharts from 'echarts-for-react';
import WidgetShell from './WidgetShell';
import { mockCashCollected, fmtAmount } from '../executiveMockData';

const CashCollectedWidget: React.FC = () => {
  const labels   = mockCashCollected.map(p => p.period);
  const actuals  = mockCashCollected.map(p => p.collected);
  const targets  = mockCashCollected.map(p => p.target);

  const latest      = mockCashCollected[mockCashCollected.length - 1];
  const prev        = mockCashCollected[mockCashCollected.length - 2];
  const moMDeltaPct = ((latest.collected - prev.collected) / prev.collected) * 100;
  const targetAchPct = (latest.collected / latest.target) * 100;

  const option = {
    grid: { left: 50, right: 16, top: 24, bottom: 28 },
    tooltip: {
      trigger: 'axis',
      formatter: (params: any[]) =>
        params.map(p => `${p.marker} ${p.seriesName}: <strong>${fmtAmount(p.value)}</strong>`).join('<br/>'),
    },
    legend: { show: true, top: 0, right: 0, fontSize: 11, itemHeight: 8, itemWidth: 14 },
    xAxis: {
      type: 'category',
      data: labels,
      axisTick: { show: false },
      axisLabel: { fontSize: 11 },
    },
    yAxis: {
      type: 'value',
      name: '₹ Cr',
      nameTextStyle: { fontSize: 10, color: '#64748b' },
      axisLabel: {
        fontSize: 10,
        formatter: (v: number) => (v / 1_00_00_000).toFixed(1),
      },
      splitLine: { lineStyle: { color: '#e5e7eb', type: 'dashed' } },
    },
    series: [
      {
        name: 'Target',
        type: 'line',
        smooth: true,
        symbol: 'none',
        lineStyle: { width: 2, type: 'dashed', color: '#94a3b8' },
        data: targets,
      },
      {
        name: 'Collected',
        type: 'bar',
        barWidth: 22,
        itemStyle: { color: '#2563eb', borderRadius: [3, 3, 0, 0] },
        data: actuals,
      },
    ],
  };

  return (
    <WidgetShell
      title="Cash Collected"
      subtitle={`Latest: ${fmtAmount(latest.collected)} · ${targetAchPct.toFixed(0)}% of target · MoM ${moMDeltaPct >= 0 ? '▲' : '▼'} ${Math.abs(moMDeltaPct).toFixed(1)}%`}
    >
      <ReactECharts option={option} style={{ height: 220, width: '100%' }} />
    </WidgetShell>
  );
};

export default CashCollectedWidget;
